import React, { Component } from 'react';

import Add from 'material-ui/svg-icons/content/add';
import Avatar from 'material-ui/Avatar';
import ContentAdd from 'material-ui/svg-icons/content/add';
import CreateProject from './project_create';
import DatePicker from 'material-ui/DatePicker'
import Dialog from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import Done from 'material-ui/svg-icons/action/done';
import FileFolder from 'material-ui/svg-icons/file/folder';
import firebaseApp from '../../firebase/firebase';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import { addVirtualAssistant, addComment, createProject, createTask, deleteProject, deleteTask, loadProjectsFromFirebase, loadAdminProjectsFromFirebase, notifyAdmin, uploadFile, sendToSlackMarketing, sendToSlackScheduling, sendToSlackContracts} from './project_actions';
import { Grid, Row, Col } from 'react-bootstrap';
import { restartTimer, setTimerProject, startTimer } from '../timetracker/timer_actions';
import {Card, CardActions, CardHeader, CardText, CardMedia } from 'material-ui/Card';
import {grey400} from 'material-ui/styles/colors';
import {List, ListItem} from 'material-ui/List';




class Projects extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      open: false,
      taskDialogOpen: false,
      emailDialogOpen: false,
      task: '',
      project: '',
      newTask: '',
      newDescription: '',
      newTitle: '',
      newVA:'',
      newEmailRecipient: '',
      newEmailBody: '',
      newEmailCC:'',
      newComment: '',
      realtor: false
      };
  }

  componentDidMount() {
    if (this.props.user.email === 'admin@mymozak.com'){
      this.props.loadAdminProjectsFromFirebase();
    } else {
      this.props.loadProjectsFromFirebase();
    }
    firebaseApp.database().ref(`users/${this.props.user.uid}`).on('value', snapshot => {
      this.setState({ realtor: snapshot.val().meta.realtor })
    })
  }

  actions = (buyer, address, city, st, zip) => {
    return (
      <div>
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />
        <FlatButton
          label="Submit"
          primary={true}
          onClick={() => this.props.createProject(buyer, address, city, st, zip)}
        />
      </div>
    )
  }

  beginTimer = (project, task, isActiveTimer, restartTimer, startTimer, setTimerProject, notifyAdmin, user) => {
    /* Gotta block off the task from others */
    const update = {}
    update[`projects/projects/${project.meta.key}/tasks/${task.key}/inprogressuser`] = user.email;
    firebaseApp.database().ref().update(update);

    setTimerProject(this.props.user, project.meta.realtor, project.location.street, task.title, project.meta.realtorid)
    notifyAdmin(this.props.user, project.meta.realtor, project.location.street, task)

    if (isActiveTimer) {
      restartTimer();
    }
    else {
      startTimer();
    }
  }

  handleAddComment = (comment, task, project, timestamp ) => {
    this.props.addComment(comment, task, project, timestamp)
  }

  handleImage = (image, project) => {
    const storageRef = firebaseApp.storage().ref();
    storageRef.child(`images/houses/${project}/house`).put(image)
    .then( snapshot => {
      const downloadURL = snapshot.downloadURL;
      const updates = {};
      updates[`projects/projects/${project}/location/image`] = downloadURL
      firebaseApp.database().ref().update(updates);
    });
  }

  handleAddVirtualAssistant = (va, key) => {
    this.props.addVirtualAssistant(va, key)
  }

  handleClose = () => {
    this.setState({open: false});
  };

  handleDeleteComment = (comment, task, project) => {
    firebaseApp.database().ref(`projects/projects/${project}/tasks/${task}/comments/${comment}`).remove()
  }

  handleDeleteFile = (docKey, docName, task, project) => {
    const storageRef = firebaseApp.storage().ref();
    storageRef.child(`files/${this.props.user.uid}/${docName}`).delete().then(
      () => {
        firebaseApp.database().ref(`projects/projects/${project}/tasks/${task}/files/${docKey}`).remove()
      })
  }

  handleDescription = (text, task, project) => {
    const updates = {}
    updates[`projects/projects/${project}/tasks/${task}/description/`] = text;
    firebaseApp.database().ref().update(updates)
  }

  handleDueDate = (date, task, project) => {
    const updates = {}
    updates[`projects/projects/${project}/tasks/${task}/duedate/`] = date;
    firebaseApp.database().ref().update(updates)
  }

  handleFiles = (doc, task, project) => {
    const storageRef = firebaseApp.storage().ref();
    storageRef.child(`files/${this.props.user.uid}/${doc.name}`).put(doc)
    .then( snapshot => {
      const downloadURL = snapshot.downloadURL;
      const Ref = firebaseApp.database().ref(`projects/projects/${project}/tasks/${task}/files`).push();
      const Key = Ref.key;
      const updates = {};
      updates[`projects/projects/${project}/tasks/${task}/files/${Key}/name`] = doc.name
      updates[`projects/projects/${project}/tasks/${task}/files/${Key}/link`] = downloadURL
      updates[`projects/projects/${project}/tasks/${task}/files/${Key}/key`] = Key
      firebaseApp.database().ref().update(updates)
    });
  }

  handleFilesProject = (doc, project) => {
    const storageRef = firebaseApp.storage().ref();
    storageRef.child(`files/${this.props.user.uid}/${doc.name}`).put(doc)
    .then( snapshot => {
      const downloadURL = snapshot.downloadURL;
      const Ref = firebaseApp.database().ref(`projects/projects/${project}/files`).push();
      const Key = Ref.key;
      const updates = {};
      updates[`projects/projects/${project}/files/${Key}/name`] = doc.name
      updates[`projects/projects/${project}/files/${Key}/link`] = downloadURL
      updates[`projects/projects/${project}/files/${Key}/key`] = Key
      firebaseApp.database().ref().update(updates)
    });
  }

  handleOpen = () => {
    this.setState({open: true});
  };

  handleSendEmail = (recipient, cc, body) => {
    fetch('https://us-central1-mozak-b40a7.cloudfunctions.net/sendEmailtoUser', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        recipient: recipient,
        cc: cc,
        body: body
      })
  });
};

  handleTitle = (title, task, project) => {
    const updates = {}
    updates[`projects/projects/${project}/tasks/${task}/title/`] = title;
    firebaseApp.database().ref().update(updates)
  }

  setTaskType = (project, task, type) => {
    const updates = {}
    updates[`projects/projects/${project.meta.key}/tasks/${task.key}/type/`] = type;
    firebaseApp.database().ref().update(updates);
  }

  renderProjects() {
    const iconButtonElement = (
      <IconButton
        touch={true}
        tooltipPosition="bottom-left"
       >
        <MoreVertIcon color={grey400} />
      </IconButton>
    );

    const rightIconMenu = (project, task) => {
      return (
        <IconMenu iconButtonElement={iconButtonElement}>
          <MenuItem onClick={()=>this.props.deleteTask(task, project)}>Done</MenuItem>
        </IconMenu>
      )
    }

    return Object.values(this.props.allProjects).map((project) => {
      return (
          <Col key={project.meta.buyer} xs={12} sm={12} md={12}>
            <Card style={{ marginTop: 15, backgroundColor: '#FAFAFA', marginLeft: -25, marginRight: -25, borderRadius: 10 }} initiallyExpanded={false}>
              <CardHeader
                title={project.meta.buyer}
                titleStyle={{ color: 'black', fontSize: 19}}
                subtitle={`${project.location.street}, ${project.location.city}, ${project.location.st}`}
                subtitleStyle={{ color: '#555555', fontSize: 12}}
                actAsExpander={true}
                showExpandableButton={true}
              />
            <Divider />
               <CardText expandable={true} style={{backgroundColor: '#455A64'}}>
                 <Row>

                  {/** IMAGES **/}
                   <Col xs={12} sm={12} md={12} lg={3}>
                     <Card style={{ marginTop: 5, backgroundColor: '#ECEFF1', borderRadius: 10 }} initiallyExpanded={true}>
                       <CardHeader title="Image" style={{ marginBottom: -20 }} titleStyle={{ fontSize: 19 }} actAsExpander={true} showExpandableButton={true}/>
                       <CardText style={{ margin: -10 }} expandable={true}>
                         <CardMedia style={{ marginBottom: 5, boxShadow: '0 1px 1px rgba(0,0,0,0.16), 0 1px 1px rgba(0,0,0,0.23)'  }}>
                           <img src={project.location.image} alt={'house'}/>
                         </CardMedia>
                       </CardText>
                       <CardActions>
                         <RaisedButton containerElement='label' label={'Upload Image'}  fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11, marginTop: 11 }}>
                           <input type="file" style={{
                             cursor: 'pointer',
                             position: 'absolute',
                             top: 0,
                             bottom: 0,
                             right: 0,
                             left: 0,
                             width: '100%',
                             opacity: 0,
                           }} onChange={(e) => this.handleImage(e.target.files[0], project.meta.key )}/>
                         </RaisedButton>
                       </CardActions>
                     </Card>
                   </Col>

                  {/** TASKS **/}
                   <Col xs={12} sm={12} md={12} lg={3} >
                     <Card style={{ marginTop: 5, backgroundColor: '#ECEFF1', borderRadius: 10 }} initiallyExpanded={true}>
                       <CardHeader title="Tasks" style={{ marginBottom: -20}} titleStyle={{ fontSize: 19 }} actAsExpander={true} showExpandableButton={true}/>
                       <CardText style={{ margin: -10 }} expandable={true}>
                         <List>
                           { !project.tasks ?
                             <ListItem style={{ fontWeight: 300, fontSize: 14 }}> No Tasks Here </ListItem> :
                               Object.values(project.tasks).map((task) =>
                               { return (
                                 <div key={task.key}>
                                   <ListItem
                                     style={{ backgroundColor: task.inprogressuser !== this.props.user.email && task.inprogressuser!=="" && this.props.user.email !== 'admin@mymozak.com' && this.props.user.email !== project.meta.realtor ? 'grey' :  'white', color: 'black', fontWeight: 400, fontSize: 14, marginBottom: 5,   boxShadow: '0 1px 1px rgba(0,0,0,0.16), 0 1px 1px rgba(0,0,0,0.23)' }}
                                     primaryText={task.title}
                                     secondaryText={!task.duedate? 'No Due Date' :`Due ${task.duedate}`}
                                     rightIconButton={task.inprogressuser !== this.props.user.email && task.inprogressuser!=="" && this.props.user.email !== 'admin@mymozak.com' && this.props.user.email !== project.meta.realtor ? null : rightIconMenu(project.meta, task )}
                                     disabled={task.inprogressuser !== this.props.user.email && task.inprogressuser !=="" && this.props.user.email !== 'admin@mymozak.com' && this.props.user.email !== project.meta.realtor}
                                     onClick={() => this.setState({ taskDialogOpen: true, task: task, project: project})}/>
                                 </div>
                               );
                             })
                           }
                           {
                             this.props.user.email === 'admin@mymozak.com' ?
                            <ListItem>
                                <TextField
                                  id ={project.location.street}
                                  onChange={(event) => this.setState({ newTask: event.target.value})}
                                  hintText="New Task"
                                  hintStyle={{ fontWeight: 300}}
                                  fullWidth={true}
                                />
                            </ListItem>
                            :
                            <br />
                          }
                         </List>
                       </CardText>
                       {
                         this.props.user.email === 'admin@mymozak.com' ?
                       <CardActions>
                         <IconButton
                           title="Add Task"
                           onClick={() => this.props.createTask(this.state.newTask, project.meta)}
                           disabled={!this.state.newTask}
                           >
                           <Add />
                         </IconButton>
                         {/*<IconButton
                           onClick={() => this.props.deleteProject(project.meta, project.users)}
                           disabled={project.meta.task_count !== 0}
                           >
                           <Done />
                         </IconButton>*/}
                       </CardActions>
                       :
                       <br />
                      }
                     </Card>
                    </Col>

                    {/** Files **/}
                    <Col xs={12} sm={12} md={12} lg={3}>
                      <Card style={{ marginTop: 5, backgroundColor: '#ECEFF1', borderRadius: 10 }} initiallyExpanded={true}>
                        <CardHeader title="Files" style={{ marginBottom: -20}} titleStyle={{ fontSize: 19 }} actAsExpander={true} showExpandableButton={true} />
                        <CardText style={{ margin: -10 }} expandable={true}>
                          <List>
                            { !project.files ?
                              <ListItem style={{ fontWeight: 300, fontSize: 14 }}> No Attached Files </ListItem> :
                                Object.values(project.files).map((file) =>
                                { return (
                                  <div key={file.key}>
                                    <ListItem
                                      href={file.link}
                                      download="proposed_file_name"
                                      style={{ backgroundColor: 'white', color: 'black', fontWeight: 400, fontSize: 14, marginBottom: 5,   boxShadow: '0 1px 1px rgba(0,0,0,0.16), 0 1px 1px rgba(0,0,0,0.23)' }}
                                      primaryText={file.name}
                                      onClick={() => console.log('wassup')} />
                                  </div>
                                );
                              })
                            }
                          </List>
                        </CardText>
                        <CardActions>
                          <RaisedButton containerElement='label' label={'Attach file'}  fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11, marginTop: 11 }} >
                            <input type="file" style={this.styles.uploadInput} onChange={(e) => this.handleFilesProject(e.target.files[0], project.meta.key)}/>
                          </RaisedButton>
                        </CardActions>
                      </Card>
                    </Col>

                  {/** Users **/}
                  <Col xs={12} sm={12} md={12} lg={3}>
                    <Card style={{ marginTop: 5, backgroundColor: '#ECEFF1', borderRadius: 10 }} initiallyExpanded={true}>
                      <CardHeader title="Users" style={{ marginBottom: -20}} titleStyle={{ fontSize: 19 }} actAsExpander={true} showExpandableButton={true} />
                      <CardText style={{ margin: -10 }} expandable={true}>
                        <List>
                          { !project.users ?
                            <ListItem style={{ fontWeight: 400, fontSize: 14 }}> No Users </ListItem> :
                              Object.values(project.users).map((user) =>
                              { return (
                                <div key={user}>
                                  <ListItem
                                    onClick={() => this.setState({ emailDialogOpen: true, newEmailRecipient: user })}
                                    style={{ backgroundColor: 'white',color: 'black', fontWeight: 400, fontSize: 14, marginBottom: 5, boxShadow: '0 1px 1px rgba(0,0,0,0.16), 0 1px 1px rgba(0,0,0,0.23)'  }}
                                    primaryText={user}
                                  />
                                </div>
                              );
                            })
                          }
                          {
                            this.props.user.email === 'admin@mymozak.com' ?
                          <ListItem>
                              <TextField
                                id ={project.location.street}
                                onChange={(event) => this.setState({ newVA: event.target.value})}
                                hintText="New VA"
                                hintStyle={{ fontWeight: 300}}
                                fullWidth={true}
                              />
                          </ListItem> :
                          <br />
                          }
                        </List>
                      </CardText>
                      {
                        this.props.user.email === 'admin@mymozak.com' ?
                        <CardActions>
                          <IconButton
                            onClick={() => this.handleAddVirtualAssistant(this.state.newVA, project.meta.key)}
                            disabled={!this.state.newVA}
                            >
                            <Add />
                          </IconButton>
                        </CardActions> :
                        <br />
                      }
                    </Card>
                  </Col>

                 </Row>
               </CardText>
            </Card>
          </Col>
        );
    });
  }
  styles = {
    uploadButton: {
      verticalAlign: 'middle',
    },
    uploadInput: {
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      width: '100%',
      opacity: 0,
    },
  };
  render() {
    let  DateTimeFormat = global.Intl.DateTimeFormat;
    return (
      <div>
        <Grid fluid style={{ marginBottom: 120 }}>
          <Row>
            {this.renderProjects()}
          </Row>
        </Grid>

        {/** FLOATING ACTION BUTTON **/}
        {
          this.props.user.email === 'admin@mymozak.com' ?
          <FloatingActionButton backgroundColor={'#F2A512'}
            style={{
              position: 'fixed',
              bottom: 100,
              right: 22
            }}
            onClick={this.handleOpen}>
            <ContentAdd />
          </FloatingActionButton> :
          <br />
        }

        {/** ADD A PROJECT DIALOG **/}
        <Dialog
          title="Add A Project"
          actions={this.actions()}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleClose}
          >
          <CreateProject/>
        </Dialog>

        {/** TASK DIALOG **/}
          <Dialog
            contentStyle={{ width: '100%', height: '100%', backgroundColor: 'black'  }}
            title={
              <div style={{ padding: 20 }}>
                <span style={{ display: 'inline-block', paddingBottom: 10 }}
                  contentEditable="true"
                  onInput={(e) => this.setState({ newTitle: e.target.innerText})}
                  onFocus={(e) => console.log('you have entered')}
                  onBlur={(e) => this.handleTitle(this.state.newTitle, this.state.task.key, this.state.project.meta.key)}
                >
                  {this.state.task.title}
                </span>
              </div>
            }
            autoScrollBodyContent={true}
            open={this.state.taskDialogOpen}
            onRequestClose={() => this.setState({ taskDialogOpen: false, taskTitle: '' })}
            style={{ marginTop: -15}}
            bodyStyle={{ backgroundColor: '#ECEFF1'}}
            >
            <Grid fluid style={{ paddingTop: 15, paddingBottom: 20 }}>
              <Row>
                <Col xs={12} sm={9}>
                  {/** DUE DATE **/}
                  <div style={{ marginBottom: 20 }}>
                    <h4 style={{ color: '#555555', display: 'inline-block' }}> Due Date </h4>
                      <DatePicker
                        hintText={!this.state.task.duedate? <span> No Due Date</span> : this.state.task.duedate}
                        formatDate={new DateTimeFormat('en-US', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                      }).format}
                      textFieldStyle={{ color: 'red' }}
                      onChange={(e,date) => this.handleDueDate(date.toLocaleDateString(), this.state.task.key, this.state.project.meta.key)}
                      />
                  </div>

                  {/** DESCRIPTION **/}
                  <div style={{ marginBottom: 24 }}>
                    <h4 style={{ color: '#555555', display: 'inline-block' }}> Description </h4>
                    <p style={{ fontSize: 12, backgroundColor: '#CFD8DC', padding: 10, borderRadius: 2 }}
                      contentEditable="true"
                      onInput={(e) => this.setState({ newDescription: e.target.innerText})}
                      onFocus={(e) => console.log('you have entered')}
                      onBlur={(e) => this.handleDescription(this.state.newDescription, this.state.task.key, this.state.project.meta.key)}
                    >
                      {!this.state.task.description? <span> Add a description</span>: this.state.task.description}
                    </p>
                  </div>

                  {/** ATTACHMENTS **/}
                  <div style={{ marginBottom: 24 }}>
                    <h4 style={{ color: '#555555', display: 'inline-block',  }}> Attachments</h4>
                    <List>
                      {
                        !this.state.task.files? <div> No Attachments</div> :
                        Object.values(this.state.task.files).map((file, i) => {
                          return (
                            <ListItem
                              style={{ backgroundColor: '#CFD8DC', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.19)'}}
                              key={i}
                              leftAvatar={<Avatar icon={<FileFolder />} />}
                              primaryText={file.name}
                              secondaryText={
                                <span>
                                  <a href={file.link} download > Download </a>
                                  <a href="#" onClick={() => this.handleDeleteFile(file.key, file.name, this.state.task.key, this.state.project.meta.key)}>Delete File</a>
                                </span>
                              }
                            />
                          )
                        })
                      }
                    </List>
                  </div>

                  {/** ADD COMMENT **/}
                  <div style={{ marginBottom: 24 }}>
                    <h4 style={{ color: '#555555', display: 'inline-block',  }}> Add A Comment</h4>
                    <p style={{ fontSize: 12, backgroundColor: '#FAFAFA', padding: 10, height: 60, borderRadius: 2, boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.19)'}}
                      contentEditable="true"
                      onInput={(e) => this.setState({ newComment: e.target.innerText})}
                      onFocus={(e) => console.log('you have entered')}
                    />
                  <RaisedButton
                    label="Save"
                    primary={true}
                    style={{}}
                    onClick={() => this.handleAddComment(this.state.newComment, this.state.task.key, this.state.project.meta.key, new Date().toLocaleString('en-us',{month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'}).split(",").join(" at ") )}
                     />
                  </div>

                  {/** COMMENTS HERE **/}
                  <div style={{ marginBottom: 24}}>
                    <h4 style={{ color: '#555555', display: 'inline-block' }}> Comments/Notes </h4>
                    <List>
                      {
                        !this.state.task.comments? <div> No Comments</div> :
                        Object.values(this.state.task.comments).map((comment, i) => {
                          return (
                            <span
                              key={i}>
                              <h5> {comment.poster}  </h5>
                              <ListItem
                                primaryText={<p style={{ fontWeight: 300, overflowWrap: 'break-word' }}>{comment.comment}</p>}
                                style={{ backgroundColor: 'white', marginBottom: 8, boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.19)'}}
                                />
                              <p style={{ fontWeight: 400, fontSize: 12 }}> {comment.timestamp} - <a href="#" onClick={() => this.handleDeleteComment(comment.key, this.state.task.key, this.state.project.meta.key)}>Delete</a> </p>

                            <Divider style={{ marginTop: 7, marginBottom: 7}} />
                          </span>
                          )
                        })
                      }
                    </List>
                  </div>


                </Col>
                <Col xs={12} sm={3}>
                  <div style={{ marginRight: -10, marginLeft: -10 }}>
                    <RaisedButton containerElement='label' label={'Attachment'}  fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11 }}>
                      <input type="file" style={this.styles.uploadInput} onChange={(e) => this.handleFiles(e.target.files[0], this.state.task.key, this.state.project.meta.key)}/>
                    </RaisedButton>
                    <RaisedButton label={'Start Working'}  disabled={!this.props.canStartTimer || this.state.realtor } fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11}} onClick={() => this.beginTimer(this.state.project, this.state.task, this.props.isActiveTimer, this.props.restartTimer, this.props.startTimer, this.props.setTimerProject, this.props.notifyAdmin, this.props.user)}/>
                    <RaisedButton label={'Send To Marketing'} fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11}} disabled={this.props.user.email !== 'admin@mymozak.com'} onClick={() => this.props.sendToSlackMarketing(this.state.project, this.state.task)}/>
                    <RaisedButton label={'Send To Contracts'} fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11}} disabled={this.props.user.email !== 'admin@mymozak.com'} onClick={() => this.props.sendToSlackContracts(this.state.project, this.state.task)}/>
                    <RaisedButton label={'Send To Scheduling'} fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11}} disabled={this.props.user.email !== 'admin@mymozak.com'} onClick={() => this.props.sendToSlackScheduling(this.state.project, this.state.task)}/>
                  </div>
                </Col>
              </Row>
            </Grid>
          </Dialog>

          {/** New Email Dialog **/}
          <Dialog
            contentStyle={{ backgroundColor: 'black' }}
            title={'New Email'}
            autoScrollBodyContent={true}
            open={this.state.emailDialogOpen}
            onRequestClose={() => this.setState({ emailDialogOpen: false, taskTitle: '' })}
            style={{ marginTop: -15}}
            bodyStyle={{ backgroundColor: '#ECEFF1'}}
            >
            <Card style={{ backgroundColor: 'white', padding: 30, marginTop: 15 }}>
              <TextField
                value={this.state.newEmailRecipient}
              />
              <br />
              <TextField
                hintText="cc:"
                onChange={(e) => this.setState({ newEmailCC: e.target.value})}
              />
              <br />
              <TextField
                hintText="Message"
                fullWidth={true}
                onChange={(e) => this.setState({ newEmailBody: e.target.value})}
              />
            <br />
          </Card>
          <CardActions>
            <RaisedButton label="Submit" primary={true} onClick={() => this.handleSendEmail(this.state.newEmailRecipient, this.state.newEmailCC, this.state.newEmailBody)}/>
            <RaisedButton label="Cancel" secondary={true}/>
          </CardActions>
          </Dialog>
      </div>
    )
  }
}



const mapStateToProps = ({ projects, timer, auth }) => {
  const { allProjects, activeProject, newTask, modalTask } = projects;
  const { canStartTimer, isActiveTimer, project } = timer
  const { user } = auth;
  return { allProjects, activeProject, newTask, modalTask, canStartTimer, isActiveTimer, project, user };
}


export default connect(mapStateToProps, {
  addVirtualAssistant,
  addComment,
  createProject,
  createTask,
  deleteProject,
  deleteTask,
  loadProjectsFromFirebase,
  loadAdminProjectsFromFirebase,
  notifyAdmin,
  restartTimer,
  sendToSlackMarketing,
  sendToSlackScheduling,
  sendToSlackContracts,
  setTimerProject,
  startTimer,
  uploadFile
})(Projects);



// WEBPACK FOOTER //
// ./src/components/project/index.js